export default __webpack_public_path__ + "static/media/plane-wing.82f8b6b5.png";